import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';

import { PoOrderDataServiceService } from 'src/app/services/po-order-data-service.service';
import { UserService } from 'src/app/services/user.service';
import { GraphService } from 'src/app/services/graph.service';
import { ApproveDialogComponent } from '../../approve-dialog/approve-dialog.component';
import { OrderDetails } from '../../model/orderdetails';
import { OrderDetailsResponse } from '../../model/orderdetailsresponse';
import { UserData } from '../../model/user-data';
import { UsersDataResponse } from '../../model/users-data-response';
import { PdfViewerComponent } from '../../pdf-viewer/pdf-viewer.component';
import { SortableColumn } from '../../model/sort/sortable-column';
import { ReportsService } from 'src/app/services/reports.service';
import { ApprovedDialogComponent } from '../../approved-dialog/approved-dialog.component';
import { HttpErrorResponse } from '@angular/common/http';
import { SlientLogoutComponent } from '../../slient-logout/slient-logout.component';
import { SsoSecurityService } from 'src/app/services/sso-security.service';
import { AuthenticationResult, PopupRequest } from "@azure/msal-browser";
import { TranslateService } from '@ngx-translate/core';
import { SessionStorageService } from 'ngx-webstorage';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { MsalService } from '@azure/msal-angular';
import { StoreMaintainenceResponse } from '../../model/store-maintainence-response';



@Component({
    selector: 'app-orderdetails',
    templateUrl: './orderdetails.component.html',
    styleUrls: ['./orderdetails.component.scss'],
    standalone: false
})
export class OrderdetailsComponent  implements OnInit,AfterViewInit {
  orderdetailsresponse:OrderDetailsResponse;
  orderdetailsdatasource: MatTableDataSource<OrderDetails>;
  sequenceNumber:number=null;
  ocRcButtonEnable:boolean=true;
 // displayedColumns: string[] = ['productdescription', 'orderqty', 'upc', 'din','orderunit'];
  displayedColumns: string[] = ['itemDescription', 'quantity', 'itemNumber','din','orderunit'];
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  userData:UserData;
  user:UsersDataResponse;
  sortableColumn:SortableColumn;
  dateTimeFormat:string='yyyy-MM-dd hh:mm:ss a';
  dateFormat:string='yyyy-MM-dd';
  minDate: Date;
  @BlockUI() blockUI: NgBlockUI;
  signReceived:boolean;




  constructor(protected route: ActivatedRoute,
    protected reportsService:ReportsService,
    protected graphservice:GraphService,
    protected authService: MsalService,protected userservice:UserService,protected poordersummaryservice: PoOrderDataServiceService,protected router:Router,protected matdialog:MatDialog,
    protected securitysso:SsoSecurityService,protected translate:TranslateService,protected session: SessionStorageService
    ) {

    this.orderdetailsresponse=new OrderDetailsResponse();

    this.userservice.getCurrentUser().subscribe(data=>{
      this.user=data;
      this.userData=data.userData;
    })

    let lang=this.userData.language.toLowerCase();
    if(lang==='fr'){
      this.dateTimeFormat="medium";
      this.dateFormat="mediumDate"

    }

  }


  ngOnInit(): void {

    this.route.parent.params.subscribe(
      (params) =>
      {

        this.sequenceNumber=params.sequenceNo;
       })



  }

  ngAfterViewInit() {
    if(this.sequenceNumber)
    this.poordersummaryservice.getPODetailsData(this.sequenceNumber).subscribe(data=>{
      this.orderdetailsresponse=data;
      this.ocAccessEnable();
      this.orderdetailsdatasource=new MatTableDataSource(data.orderDetailsDtoList);
      this.orderdetailsdatasource.paginator = this.paginator;
      this.orderdetailsdatasource.sort=this.sort;
     });


  }

  openReport(reportData,dialogData){


    this.matdialog.open(PdfViewerComponent, {
      width: '100%',
      maxWidth: '90%',
      height: 'auto',
      data: {
        title: dialogData.title,
        srcType: 'Binary',
        pdfData: new Blob([reportData], { type: 'application/pdf' }),
        downloadFileName: dialogData.downloadFileName,
        downLoadFile:true
      }
    });


  }

  sortData(sort: Sort) {
    this.sortableColumn=new SortableColumn('','','');
    const sortedData: boolean | Array<any> = this.sortableColumn.sortTableData(sort, this.orderdetailsdatasource.data, this.displayedColumns);
    if (sortedData) {
      this.orderdetailsresponse.orderDetailsDtoList = sortedData as Array<any>;
    }
  }

  approveOC(){
    let token=this.userservice.getObject("Reauthorization");
    let tokenValid=token?this.isTokenExpired(token):false;
    if(tokenValid){
      let dialogData= {
        title:  this.userData.language==='EN'?'Authenticate to Approve': 'Authentifiez pour approuver',
        message: "",
        orderType:'OC'

      }
      this.matdialog.open(ApprovedDialogComponent,{
        data:dialogData,panelClass: 'appoved-class'
      }).afterClosed().subscribe(actionName => {
        if (actionName === true) {
           this.openReportData();
        }
      });
    }else{
      // Popup reauth via MSAL v5 redirect bridge (/redirect) — COOP-safe
      this.startMsalPopupReauth(() => this.openReportData());
    }
  }

  /**
   * Interactive reauth in a popup. Requires MSAL redirectUri = {origin}/redirect
   * and the /redirect bridge page (broadcastResponseToMainFrame).
   */
  protected startMsalPopupReauth(onSuccess: () => void): void {
    const loginRequest: PopupRequest = {
      scopes: ['openid', 'profile', 'User.Read'],
      prompt: 'login',
      redirectUri: `${window.location.origin}`
    };
    this.signReceived = false;
    this.toggleBlocking();
    this.authService.loginPopup(loginRequest).subscribe({
      next: (response: AuthenticationResult) => {
        this.blockUI.stop();
        this.signReceived = true;
        this.graphservice.getProfile().then(u => {
          if (u && response.account?.username &&
              u.toUpperCase() === response.account.username.toUpperCase()) {
            this.userservice.setObject('Reauthorization', response.idToken);
            onSuccess();
          } else {
            this.userservice.setUnauthorized();
            this.authService.logoutRedirect();
          }
        });
      },
      error: (error) => {
        this.blockUI.stop();
        console.error(error);
      }
    });
  }



 openReportData(){
 let str:StoreMaintainenceResponse =this.user.stores.find(str=> str.storeNumber===""+this.orderdetailsresponse.storeNumber);
 let po_extensiton={"firstName":this.userData.firstName,"lastName":this.userData.lastName,"license": str.license};
  this.poordersummaryservice.approveOC(this.sequenceNumber,this.userData.sequenceNumber,po_extensiton).subscribe(data=>{
   //NEED to verify -24/04/2022
    this.orderdetailsresponse.status=4;
    //NEED to verify -24/04/2022
    this.orderdetailsresponse.statusName="Signed";
    this.ocAccessEnable();
   this.openReportPDF();

    })
 }



 openReportPDF(){
  this.reportsService.getSignedResultsReports(this.sequenceNumber).subscribe(data=>{
    let contentDispositionHeader= data.headers.get('Content-Disposition')
  var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
  result.replace(/"/g, '');
  console.log(result);
  let dialogData= {
  title: result,
    downloadFileName: result,
    downLoadFile:true
  }
    this.openReport(data.body,dialogData);
  })
 }



  backToSummary(){

    if(this.userData && this.userData.roleId>3){
      this.router.navigate(["/dcn-esign/order-summary/order-details",this.orderdetailsresponse.storeNumber]);
      }else
      if(this.userData && this.userData.roleId<4){
        this.router.navigate(["/dcn-esign/order-summary/order-details",this.orderdetailsresponse.dcNumber?this.orderdetailsresponse.dcNumber:30]);
      }


  }

  toggleBlocking() {
    this.blockUI.start(this.userData.language==='EN'?"Complete the authentication step in the newly opened verification window.": "Veuillez compléter l'étape d'authentification dans la fenêtre de vérification nouvellement ouverte.");

    setTimeout(() => {
      this.blockUI.stop();
      if(this.signReceived===false){
      window.location.reload();
    }
    }, 90000);

  }





  backToReceiveConfirmation(){
    this.route.parent.params.subscribe(
      (params) =>
      {

        this.sequenceNumber=params.sequenceNo;

    this.router.navigate(['/dcn-esign/order-summary/receipt-confirmation/'+this.sequenceNumber]);

  })


  }

  ocAccessEnable(){


   if(this.orderdetailsresponse.status<4 && this.userData.roleId>3){

  this.ocRcButtonEnable=false;
   }else{
    this.minDate = new Date(this.orderdetailsresponse.receivedDate);
    this.ocRcButtonEnable=true;
   }

  }

  protected isTokenExpired(token: string) {
    const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    return expiry * 1000 > Date.now();
  }


}
